import React from "react";
import { inject, observer } from "mobx-react";
import DatePickerInput from "../common/form/DatePickerInput";
import RequiredFieldLabel from "../common/form/RequiredFieldLabel";
import ReportFooterButtons from "./ReportFooterButtons";

class GamesAndDateRangeBatchContent extends React.Component {
  render() {
    let reportStore = this.props.rootStore.reportStore;
    return (
      <div className="row">
        <div className="col">
          <form
            onSubmit={event => {
              event.preventDefault();
              reportStore.runReport();
            }}
          >
            <div className="row">
              <div className="col-lg-2 col-sm-6">
                <label className="col-form-label">Game Start Date</label>
                <DatePickerInput date={reportStore.dateRange.start} onChange={reportStore.setStartDate} />
              </div>
              <div className="col-lg-2 col-sm-6">
                <label className="col-form-label">Game End Date</label>
                <DatePickerInput date={reportStore.dateRange.end} onChange={reportStore.setEndDate} />
              </div>
              <div className="col-lg-4 col-sm-6">
                <label className="col-form-label">Game PKs</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Comma separated game pks"
                  value={reportStore.gamePks}
                  onChange={reportStore.setGamePks}
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <label className="col-form-label">
                  Send To The Following Email
                  <RequiredFieldLabel />
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Comma separated email addresses"
                  value={reportStore.userStr}
                  onChange={reportStore.setUsers}
                />
              </div>
            </div>
            <ReportFooterButtons />
          </form>
        </div>
      </div>
    );
  }
}

export default inject("rootStore")(observer(GamesAndDateRangeBatchContent));
